var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-btn',_vm._b({attrs:{"tile":"","depressed":"","color":"secondary"},on:{"click":function($event){return _vm.downloadOrderReport()}}},'v-btn',_vm.$attrs,false),[_vm._v(" "+_vm._s(_vm.$t('admin.downloadOrderReport'))+" ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }